<template>
   <div class="inline">
     <div>
       <p v-if="profile_v2.type === 4" class="text-blue" v-on:mouseover="hover(true)" v-on:mouseout="hoverOut">{{ AssociatedText }}</p>
       <p v-else class="text-blue" v-on="{ mouseover:profile_v2.type <= popUpUser.type ? $event => hover(true) : $event => hover(false) }" v-on:mouseout="hoverOut">{{ AssociatedText }}</p>
     </div>
      <div class="user-popover rounded-lg ml-6 p-3 px-4" v-if="showPopup" transition="fade" v-on:mouseover="hoverInfo" v-on:mouseout="hoverOutInfo">
        <div class="w-full">
          <p class="text-left text-xs align-top mb-4">Visible On:</p>
        </div>
        <div class="flex flex-col h-32 scrollbar p-1">
          <div class="mb-2 border-b" v-for="officeCheckbox in checkBoxOfficList" :key="officeCheckbox.id">
            <div v-if="profile_v2.type === 3 || profile_v2.type === 2 || profile_v2.type === 1" class="flex flex-row justify-between mb-1">
              <div class="w-36 mr-1"><p class="text-xs text-left">{{officeCheckbox.name}}</p></div>
              <div class="mr-1">
                <input :id="officeCheckbox.id" :value="officeCheckbox.id" type="checkbox" v-bind:checked="popUpUser.associated_office.includes(officeCheckbox.id)" @click="addOffice(officeCheckbox.id, popUpUser)"/>
                <label :for="officeCheckbox.id"></label>
              </div>
            </div>
            <div v-else-if="profile_v2.type === 4" class="flex flex-row justify-between mb-1" :class="{'opacity-25': !popOverAuthUserList.includes(officeCheckbox.id)}">
              <div class="w-36 mr-1"><p class="text-xs text-left">{{officeCheckbox.name}}</p></div>
              <div class="mr-1">
                <input :id="officeCheckbox.id" :value="officeCheckbox.id" type="checkbox" v-bind:checked="popUpUser.associated_office.includes(officeCheckbox.id)" :disabled="!popOverAuthUserList.includes(officeCheckbox.id)" @click="addOffice(officeCheckbox.id, popUpUser)"/>
                <label :for="officeCheckbox.id"></label>
              </div>
            </div>
            <div v-else class="flex flex-row justify-between mb-1" :class="{'opacity-25': (!popOverAuthUserList.includes(officeCheckbox.id) && (profile_v2.type > 4))}">
              <div class="w-36 mr-1"><p class="text-xs text-left">{{officeCheckbox.name}}</p></div>
              <div class="mr-1">
                <input :id="officeCheckbox.id" :value="officeCheckbox.id" type="checkbox" v-bind:checked="popUpUser.associated_office.includes(officeCheckbox.id)" :disabled="((!popOverAuthUserList.includes(officeCheckbox.id) && (profile_v2.type > 4)))"  @click="addOffice(officeCheckbox.id, popUpUser)"/>
                <label :for="officeCheckbox.id"></label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <deletion-modal
      v-if="deleteUserModalpop"
      @confirmed="deleteUser(deleteUserModalpop)"
      @leave="deleteUserModalpop = null"
      @dismissed="deleteUserModalpop = null">
      <p class="text-center"> User <strong>{{deleteUserModalpop.name}} </strong> is only associate to <strong>One</strong> office if you remove this the user will be automatically deleted ?</p>
    </deletion-modal>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import api from '@/http'
import _ from 'lodash'
import DeletionModal from '@/components/Modals/DeletionModal'
export default {
  components: {
    DeletionModal
  },
  props: [
    'userAssociatedText', 'popUpUser'
  ],
  computed: {
    ...mapState(['selectedOffice', 'profile_v2'])
  },
  data () {
    return {
      showPopup: false,
      timer: '',
      isInInfo: false,
      checkBoxOfficList: null,
      popOverAuthUserList: [],
      AssociatedText: '',
      deleteUserModalpop: false
    }
  },
  created () {
    this.collateAuthUserList()
    this.getUserAssociatedText()
  },
  methods: {
    ...mapActions([
      'displayToastNotification'
    ]),
    deleteUser (user) {
      api
        .delete(`deleted-user/${user.id}`)
        .then(response => {
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'User deleted ',
            info: 'Your user has been deleted successfully.'
          })
          this.getPagenatedUsers()
          this.deleteUserModal = false
        },
        error => {
          this.errorBag.store(error.response.data)
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-times-circle',
            title: 'User deleting',
            info: 'Error deleting User.'
          })
        })
    },
    addOffice (officeId, user) {
      // in here you can check what ever condition  before append to array.
      if (user.associated_office.length === 1 && user.associated_office.includes(officeId) && user.type === 8) {
        this.deleteUserModalpop = user
        return
      }
      if (this.popUpUser.associated_office.includes(officeId)) {
        this.popUpUser.associated_office = _.without(this.popUpUser.associated_office, officeId)
      } else {
        this.popUpUser.associated_office.push(officeId)
      }
      this.saveUser(this.popUpUser)
    },
    getUserAssociatedText () {
      var count = this.popUpUser.associated_office.length
      if (count === 0) {
        this.AssociatedText = 'Not Visible on Office pages'
        return
      }
      if (count === 1) {
        this.AssociatedText = this.userAssociatedText
        return
      }
      this.AssociatedText = count + ' X Offices'
    },
    saveUser (val) {
      val['office_id'] = this.selectedOffice.id
      api.patch('/update-user/' + val.id, val).then(
        response => {
          this.getUserAssociatedText()
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'User Updated',
            info: 'Your user has been updated successfully.'
          })
        },
        error => {
          this.errorBag.store(error.response.data)
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-times-circle',
            title: 'User',
            info: 'Error saving User.'
          })
        }
      )
    },
    collateAuthUserList () {
      this.profile_v2.offices.forEach(office => {
        this.popOverAuthUserList.push(office.id)
      })
    },
    getOfficeListAssociate () {
      var params = {
        office_id: this.selectedOffice.id
      }
      api.get('/user-office-list-associate/' + this.popUpUser.id, { params }).then(response => {
        this.checkBoxOfficList = response.data
      }).catch(({ response }) => {
        if (response.status === 422) {
        }
      })
    },
    hover (check) {
      if (!check) {
        return
      }
      this.getOfficeListAssociate()
      let vm = this
      this.timer = setTimeout(function () {
        vm.showPopover()
      }, 600)
    },

    hoverOut () {
      let vm = this
      clearTimeout(vm.timer)
      this.timer = setTimeout(function () {
        if (!vm.isInInfo) {
          vm.closePopover()
        }
      }, 200)
    },

    hoverInfo () {
      this.isInInfo = true
    },

    hoverOutInfo () {
      this.isInInfo = false
      this.hoverOut()
    },

    showPopover () {
      this.showPopup = true
    },

    closePopover () {
      this.showPopup = false
    }
  }
}
</script>
<style lang="scss" scoped>
  .inline{
    display: inline-block;
    position: relative;
  }
  .user-popover{
    position: absolute;
    left: 100%;
    bottom: -120%;
    background: #707070;
    border: 1px solid #fff;
    color: #fff;
    z-index:999;
  }

  .scrollbar {
    scrollbar-width: 1px; /* for Firefox */
    overflow-x: scroll !important;
  }

  .user-popover:before {
  content:"";
    position: absolute;
    height: 0px;
    width: 0px;
    bottom: 10px;
    left: -29px; /* 1px buffer for zooming problems while rendering*/
    border-width: 15px;
    border-color: transparent #707070 transparent transparent;
    border-style: solid;
  }

</style>
